import { Component, ElementRef, OnInit, Renderer2, ViewChild, ViewEncapsulation, HostListener } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { Router } from '@angular/router';
import { AuthService } from 'app/service/auth/auth.service';
import { GlobalService } from 'app/shared/global.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class HomeComponent implements OnInit {
  Today = new Date();

  images = [
    'assets/img/sl1.jpg',
    'assets/img/sl2.jpg',
    'assets/img/sl3.jpg',
    'assets/img/sl4.jpg',
    'assets/img/sl5.jpg',
    'assets/img/sl6.jpg',
    'assets/img/sl7.jpg',
    'assets/img/sl8.jpg',
    'assets/img/sl9.jpg',
    'assets/img/sl10.jpg',

    // Add more image paths as needed
  ];

  // images1 = [
  //   { src: 'assets/img/Home Slider/1_text.jpg', alt: 'image' },
  //   { src: 'assets/img/Home Slider/2_text.jpg', alt: 'image' },
  //   { src: 'assets/img/Home Slider/3_text.jpg', alt: 'image' },
  //   { src: 'assets/img/Home Slider/4_text.jpg', alt: 'image' },
  //   { src: 'assets/img/Home Slider/0.JPG', alt: 'image' },
  //   { src: 'assets/img/Home Slider/campus92.JPG', alt: 'image' },
  //   // { src: 'assets/img/Home Slider/campus9.jpeg', alt: 'image' },
  //   { src: 'assets/img/Home Slider/2.jpeg', alt: 'image' },
  //   { src: 'assets/img/Home Slider/3.jpg', alt: 'image' },
  //   { src: 'assets/img/Home Slider/4.jpg', alt: 'image' },
  //   { src: 'assets/img/Home Slider/5.png', alt: 'image' },
  //   { src: 'assets/img/Home Slider/6.jpg', alt: 'image' },
  //   { src: 'assets/img/Home Slider/7.jpg', alt: 'image' },
  //   { src: 'assets/img/Home Slider/8.jpg', alt: 'image' },
  //   { src: 'assets/img/Home Slider/9.jpg', alt: 'image' },
  //   { src: 'assets/img/Home Slider/10.jpg', alt: 'image' },
  //   { src: 'assets/img/Home Slider/11.jpg', alt: 'image' },
  //   { src: 'assets/img/Home Slider/12.jpg', alt: 'image' },
  //   // Add more image paths as needed
  // ];



  images1 = [
    // { src: 'assets/img/Home Slider/1_text.jpg', alt: 'image' },
    // { src: 'assets/img/Home Slider/2_text.jpg', alt: 'image' },
    // { src: 'assets/img/Home Slider/3_text.jpg', alt: 'image' },
    // { src: 'assets/img/Home Slider/4_text.jpg', alt: 'image' },
    { src: 'assets/img/Home Slider/Entrance.JPG', alt: 'image' },
    { src: 'assets/img/Home Slider/Ashram Campus-2.JPG', alt: 'image' },
    // { src: 'assets/img/Home Slider/campus9.jpeg', alt: 'image' },
    { src: 'assets/img/Home Slider/Ashram Campus-3.JPG', alt: 'image' },
    // { src: 'assets/img/Home Slider/Female Therapy Center.JPG', alt: 'image' },
    // { src: 'assets/img/Home Slider/Male Therapy Center.JPG', alt: 'image' },
    { src: 'assets/img/Home Slider/Neurotherapy.JPG', alt: 'image' },
    { src: 'assets/img/Home Slider/Office & Medical Block.JPG', alt: 'image' },
    // { src: 'assets/img/Home Slider/Wifi Zone.JPG', alt: 'image' },
    { src: 'assets/img/Home Slider/Yoga Hall-2 I.JPG', alt: 'image' },
    { src: 'assets/img/Home Slider/Yoga Hall-2 O.JPG', alt: 'image' },
    { src: 'assets/img/Home Slider/Yoga Niketan & Library.JPG', alt: 'image' },
    // { src: 'assets/img/Home Slider/11.jpg', alt: 'image' },
    // { src: 'assets/img/Home Slider/12.jpg', alt: 'image' },
    // Add more image paths as needed
  ];



  
  text = [
    "The serene environment and personalized naturopathy treatments at Uruli Kanchan completely rejuvenated my body and mind. The combination of Ayurvedic therapies, yoga, and a sattvic diet helped me regain my vitality naturally. A truly transformative experience!",
    "After years of struggling with lifestyle disorders, I found solace in the holistic therapies at Uruli Kanchan. Detox treatments, hydrotherapy, and nature walks worked wonders on my overall well-being. I now feel lighter, healthier, and more in tune with nature!",
    "I visited Uruli Kanchan for a stress relief program, and it was the best decision of my life. The calming atmosphere, expert naturopaths, and traditional healing methods helped me restore my energy and inner peace. Truly, nature is the best healer!"
  ];

  img = [
    'assets/img/user-1.jpg',

    // Add more image paths

  ];
  textt = [

    { id: 1, Image: "assets/img/demoUser.png", Name: "-Padmashree Dr Abhay Bang ", feedback: " I have heard the name of this organization for last fifty years. I am glad to witness the Ashram. The premises, Ashram routine, kitchen & treatment are laid down thoughtfully and well maintained. If research is added to naturopathy, it ll empower the people to adopt and stay healthy. My best wishes to the team." },
    { id: 2, Image: "assets/img/demoUser.png", Name: "-PRAKASH & MANDA AMATE", feedback: " I came here with my mother when I was a child. After that I was just listening to the information about the naturopathy center here.Today I suddenly got a chance to see this center and felt very contented." },
    { id: 3, Image: "assets/img/demoUser.png", Name: "-Mrs. S. M. Godse", feedback: " It is my first visit to this trust. The care taker & one of the trustee with one doctor attend me. They show me area to his naturopathy clinic. It is very pleasant and calm. Staff members are found to be sufficient. The trust is working well. The staff members. Trustee & doctors are found to be dedicated to the work. It is very nice place. Thank you." },
    { id: 4, Image: "assets/img/demoUser.png", Name: "-Actor Nikhil Ratnaparkhi ", feedback: " Very nice place & environment. The most important thing is that the people here are very nice. Everyone from the doctors to the room cleaning staff is very nice. The beauty of nature of this place makes you want to come here again and again." },
    { id: 5, Image: "assets/img/demoUser.png", Name: "-Actor Jitendra Joshi ", feedback: " In a world where money is the order of the day, there exists such an amazing charitable organization which strengthens our faith in humanity. All doctors and  staffs serve whole heartedly. It’s a beautiful, serene and lush green campus; Had both Joy and contentment to its fullest extent." },
    { id: 6, Image: "assets/img/demoUser.png", Name: "-Mrs. Bebytai gaikwad ", feedback: " I was overwhelmed when I was saw this organization. Seeing their work, I actually remembered Mahatma Gandhi, Vinoba Bhave’s thoughts which I read from books but never knew that their thoughts have made real in this very place. Its overwhelming to see that the Gandhian thoughts are preached for better life." },
    { id: 7, Image: "assets/img/demoUser.png", Name: "-Sharad Upadhye ", feedback: " From 12 June to 14 June 2014 I got opportunity to stay in ashram. I was impressed by ashram staff’s hospitality, humility and atmosphere of peace. Satvik food, nature and smiling doctor’s make all the ailments go away automatically.Ashram’s management arranged my lecture for two days which gave me lot of joy and funtime for the sadhakas. This is my 11th visit in ashram. Every time I come here, it feels I am at the heaven on earth." },
    { id: 8, Image: "assets/img/demoUser.png", Name: "-Deepak kesarkar ", feedback: " The organization has kept alive the teachings of Mahatma Gandhiji by way of effective demonstrations & practice. It was indeed an inspiring and invigorating day that I spent at the ashram. My best wishes to you all. May you continue to travel on the path laid by Gandhiji & contribute towards heathier Maharashtra." },
  ];

  slideConfig = {
    "slidesToShow": 1,
    "slidesToScroll": 1,
    "arrows": false
  };

  constructor(
    public translate: TranslateService,
    private router: Router,
    private authService: AuthService,
    public globals: GlobalService,
    private renderer: Renderer2) { }

  currentSlide = 0;
  containerPosition = 0;
  imageContainerWidth: number;

  navigateToHome() {
    // Navigate to the current route (refresh the page)
    //this.router.navigate(['/session/home']);
    this.router.navigateByUrl('/session/home').then(() => {
      // Then hide the route from the URL
      history.replaceState({}, '', '/');
    });
  }

  changeLanguage(lang: string) {
    console.log('Language changed to:', lang);
    // Implement ngx-translate logic here
  }

  showSlide() {
    // Update the left position of the image container
    this.containerPosition = -this.currentSlide * 100;
  }

  prevSlide(event: Event): void {
    event.preventDefault();
    this.images.push(this.images.shift()); // Move the first image to the end of the array
    this.text.push(this.text.shift());
    this.textt.push(this.textt.shift());
  }

  nextSlide(event: Event): void {
    event.preventDefault();
    this.images.push(this.images.shift()); // Move the first image to the end of the array
    this.text.push(this.text.shift());
    this.textt.push(this.textt.shift());
  }

  // About details
  isAbout = false;
  isHistory = false;
  isObjectofthetrust = false;
  isTrustees = false;
  isDoctors = false;
  isAdayAtAshram = false;
  isThingstoCarry = false;
  isRules = false;
  isLocation = false;
  isNatureCure = false;
  isTestimonials = false;
  isWorkshops = false;
  isDincharya = false;
  // GetAboutDetails(Type) {
  //   // document.getElementById("navbarSupportedContentID").click();
  //   this.istariff = false;
  //   this.isAbout = false;
  //   this.istherapies = false;
  //   this.isfacilities = false;
  //   this.isHistory = false;
  //   this.isObjectofthetrust = false;
  //   this.isTrustees = false;
  //   this.isDoctors = false;
  //   this.isAdayAtAshram = false;
  //   this.isThingstoCarry = false;
  //   this.isbooking = false;
  //   this.isRules = false;
  //   this.isLocation = false;
  //   this.isgallery = false;
  //   this.isNatureCure = false;
  //   this.isTestimonials = false;
  //   this.isWorkshops = false;
  //   this.isDincharya = false;
  //   if (Type == 'History') {
  //     this.isAbout = true;
  //     this.isHistory = true;
  //   } else if (Type == 'Objectofthetrust') {
  //     this.isAbout = true;
  //     this.isObjectofthetrust = true;
  //   } else if (Type == 'Trustees') {
  //     this.isAbout = true;
  //     this.isTrustees = true;
  //   } else if (Type == 'Doctors') {
  //     this.isAbout = true;
  //     this.isDoctors = true;
  //   } else if (Type == 'AdayAtAshram') {
  //     this.isAbout = true;
  //     this.isAdayAtAshram = true;
  //   } else if (Type == 'ThingstoCarry') {
  //     this.isAbout = true;
  //     this.isThingstoCarry = true;
  //   } else if (Type == 'Rules') {
  //     this.isAbout = true;
  //     this.isRules = true;
  //   } else if (Type == 'Location') {
  //     this.isAbout = true;
  //     this.isLocation = true;
  //   } else if (Type == 'NatureCure') {
  //     this.isAbout = true;
  //     this.isNatureCure = true;
  //   } else if (Type == 'Testimonials') {
  //     this.isAbout = true;
  //     this.isTestimonials = true;
  //   }
  //   else if (Type == 'Workshops') {
  //     this.isAbout = true;
  //     this.isWorkshops = true;
  //   }
  // }

  // therapies Details
  istherapies = false;
  istreatmentphilosopy = false;
  istreatments = false;

  // GettherapiesDetails(T) {
  //   this.isbooking = false;
  //   this.istariff = false;
  //   this.isAbout = false;
  //   this.istherapies = false;
  //   this.isfacilities = false;
  //   this.istreatmentphilosopy = false;
  //   this.isgallery = false;
  //   this.istreatments = false;
  //   this.isDincharya = false;
  //   if (T == 'treatmentphilosopy') {
  //     this.istherapies = true;
  //     this.istreatmentphilosopy = true;
  //   } else if (T == 'treatments') {
  //     this.istherapies = true;
  //     this.istreatments = true;
  //   }
  // }

  isfacilities = false;
  isfacilitie = false;
  isservices = false;
  isonlineyoga = false;
  // GetfacilitiesDetails(T) {
  //   this.istariff = false;
  //   this.isAbout = false;
  //   this.istherapies = false;
  //   this.isfacilitie = false;
  //   this.isfacilities = false;
  //   this.isservices = false;
  //   this.isonlineyoga = false;
  //   this.istreatments = false;
  //   this.istreatmentphilosopy = false;
  //   this.isbooking = false;
  //   this.isDincharya = false;

  //   if (T == 'isservices') {
  //     this.isfacilities = true;
  //     this.isservices = true;
  //   } else if (T == 'isonlineyoga') {
  //     this.isfacilities = true;
  //     this.isonlineyoga = true;
  //   } else if (T == 'isfacilitie') {
  //     this.isfacilities = true;
  //     this.isfacilitie = true;
  //   }
  // }

  //tariff Details

  istariff = false;

  // GettariffDetails(Type) {
  //   this.istariff = false;
  //   this.isAbout = false;
  //   this.istherapies = false;
  //   this.isfacilities = false;
  //   this.isservices = false;
  //   this.isonlineyoga = false;
  //   this.isfacilitie = false;
  //   this.isgallery = false;
  //   this.istreatments = false;
  //   this.isbooking = false;
  //   this.istreatmentphilosopy = false;
  //   this.isDincharya = false;

  //   if (Type == 'tariff') {
  //     this.istariff = true;

  //   }
  //   if (Type == 'Donation') {
  //   }
  // }

  isbooking = false;
  // GetBookingDetails(T) {
  //   this.isAbout = false;
  //   this.isbooking = false;
  //   this.isDincharya = false;
  //   this.istherapies = false;
  //   this.isfacilities = false;
  //   this.istariff = false;
  //   if (T == 'Book') {
  //     this.isbooking = true;
  //   }
  //   if (T == 'Dincharya') {
  //     this.isDincharya = true;
  //   }
  // }

  //gallery Details

  isgallery = false;
  iscampus = false;

  // GetgalleryDetails(Type) {
  //   this.istariff = false;
  //   this.isAbout = false;
  //   this.istherapies = false;
  //   this.isfacilities = false;
  //   this.isservices = false;
  //   this.isonlineyoga = false;
  //   this.isfacilitie = false;
  //   this.isgallery = false;
  //   this.isbooking = false;
  //   this.isDincharya = false;
  //   this.iscampus = false;
  //   if (Type == 'gallery') {
  //     this.isgallery = true;
  //   } else if (Type == 'campus') {
  //     this.iscampus = true;
  //   }
  // }

  @ViewChild('videoPlayer') videoPlayer: ElementRef;

  ngOnInit() {
    // Check if the page is being loaded initially or refreshed
    // const isPageRefresh = performance.navigation.type === 1;
    this.globals.UserName = '';
    this.globals.UserID = 0;
    this.authService.logOut();
    this.router.navigateByUrl('/session/home').then(() => {
      history.replaceState({}, '', '/');
    });
  }

  ngAfterViewInit() {
    // Access the video element using the ViewChild
    const video: HTMLVideoElement = this.videoPlayer.nativeElement;
    // Set autoplay and mute the video initially
    video.autoplay = true;
    video.muted = true;
    setTimeout(() => {
      // Function to unmute the video and play it
      const unmuteVideo = () => {
        video.muted = false; // Unmute the video
        document.removeEventListener('click', unmuteVideo); // Remove the event listener
        // Play the video
        video.play()
          .then(() => {
          })
          .catch((error) => {
            console.error('Error playing video:', error);
          });
      };
      // Add event listener to detect when video is played
      document.addEventListener('click', unmuteVideo, { once: true });
    }, 1000);
  }
}